import { CheckMarkList } from '../check-mark-list';
import { desktop, tablet } from '@thrivent/midwest-shared';
import { MDSText } from '@thrivent/midwest-web';
import styled from 'styled-components';

export interface ContentBlockProps {
  headline: string;
  subHeadline: string;
  checkMarkItems?: string[];
}

const Content = styled.div`
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const ContentText = styled(MDSText.BodyRegDefault)`
  padding-bottom: 0.5rem;
  ${desktop} {
    max-width: 27rem;
  }
`;

const Title = styled(MDSText.TitleMd)`
  padding-bottom: 0.5rem;

  ${tablet} {
    margin: 0;
  }
`;

const SubHeadline = styled(MDSText.BodyRegDefault)``;

const ContentBlock: React.FC<ContentBlockProps> = ({
  headline,
  subHeadline,
  checkMarkItems,
}) => {
  return (
    <Content>
      <ContentText>
        <Title as="h3">{headline}</Title>
        <SubHeadline as="p">{subHeadline}</SubHeadline>
      </ContentText>
      {checkMarkItems && <CheckMarkList items={checkMarkItems} />}
    </Content>
  );
};
export default ContentBlock;
